import {
  EnvIdentifier,
  EnvironmentSettings,
  LogLevel,
} from './environment-types';

export const environment: EnvironmentSettings = {
  production: false,
  apiUrl: 'https://server.test.zaver.com/business',
  wsUri: 'wss://server.test.zaver.com/business/socket/websocket',
  useFixtures: false,
  environment: EnvIdentifier.TEST,
  logSettings: {
    minLevels: {
      telemetry: LogLevel.NONE,
      console: LogLevel.ALL,
      stash: LogLevel.ALL,
    },
    routerLog: false,
  },
};
